import { observer } from "mobx-react-lite";
import { FC, useCallback } from "react";
import { PlatformIconKind } from "@/domains/api/types";
import { useAppBannerLinkOnClickHandler } from "@/components/banners/app-callout-banner/utils/app-banner-link-handling";
import { useResolvePlatformIconData } from "@/components/icons";
import { TrackedEvent, trackEvent } from "@/domains/metrics";
import { MDSButton, MDSIcon, MDSButtonSlotName, MDSButtonVariant } from "@/mds";

interface AppCalloutBannerActionButtonProps {
  iconKind: PlatformIconKind | null;
  label: string | null;
  url: string | null;
}

export const AppCalloutBannerActionButton: FC<AppCalloutBannerActionButtonProps> = observer(
  ({ iconKind, label, url }) => {
    const { onClickHandler } = useAppBannerLinkOnClickHandler({ url: url || "" });
    const onClick = useCallback(() => {
      trackEvent(TrackedEvent.ChromeExtensionHomeCarouselInstallerClick, { label });
      onClickHandler();
    }, [label, onClickHandler]);

    const result = useResolvePlatformIconData({ iconKind });
    const parsedMDSIconKind = result?.icon;

    if (!label) return null;
    if (!url) return null;

    return (
      <MDSButton onClick={onClick} variant={MDSButtonVariant.ContrastAccent}>
        {parsedMDSIconKind && (
          <MDSIcon slot={MDSButtonSlotName.LeftIcon} kind={parsedMDSIconKind} />
        )}
        {label}
      </MDSButton>
    );
  }
);
